<template>
  <div class="article-details">
    <div v-if="article" class="article-container">
      <div class="article-header">
        <h1 class="article-title">{{ article.title }}</h1>
        <div class="article-meta">
          <span class="category-tag" :class="getCategoryClass(article.category)">{{ article.category }}</span>
          <time class="publish-time">{{ formatDate(article.publishTime) }}</time>
          <span v-if="article.isPaid" class="price-tag">¥{{ article.price }}</span>
        </div>
      </div>

      <div class="article-content">
        <div class="content-box" ref="contentBox" :style="contentBoxStyle">
          <pre ref="contentText">{{ article.content }}</pre>
          <div v-if="showReadMore && contentBoxStyle.maxHeight === '300px'" class="read-more">
            <a href="#" class="readMoreButton" @click.prevent="handleReadMore">付费阅读更多</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="loading">
      加载中...
    </div>

    <!-- Payment Modal -->
    <div v-if="showPaymentModal" class="payment-modal">
      <div class="payment-modal-content">
        <div class="payment-modal-header">
          <h2>请使用支付宝扫码支付</h2>
          <span class="close-btn" @click="closePaymentModal">&times;</span>
        </div>
        <div class="payment-modal-body">
          <img src="@/assets/pay.png" alt="支付二维码" class="payment-qr-code" />
          <p class="payment-amount">支付金额: ¥{{ article && article.price }}</p>
          <button class="payment-confirm-btn" @click="handlePaymentConfirm">已支付</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  data() {
    return {
      article: null,
      isLoggedIn: false,
      showReadMore: false,
      showPaymentModal: false,
      contentBoxStyle: {
        maxHeight: '300px',
        overflow: 'hidden'
      }
    };
  },
  created() {
    this.checkLoginStatus();
    this.loadArticle();
    eventBus.$on('login-status-changed', this.checkLoginStatus);
  },
  beforeDestroy() {
    eventBus.$off('login-status-changed', this.checkLoginStatus);
  },
  mounted() {
    this.$nextTick(() => {
      this.checkContentHeight();
    });
  },
  methods: {
    checkLoginStatus() {
      const currentUser = localStorage.getItem('currentUser');
      const isAdmin = localStorage.getItem('isAdmin') === 'true';
      this.isLoggedIn = Boolean(currentUser) || isAdmin;
    },
    loadArticle() {
      const articleId = parseInt(this.$route.params.id);
      const articles = {
        1001: {
          id: 1001,
          title: '70个医学健康小知识，每个人都应该看看',
          category: '就医相关',
          content: '70个医学健康小知识，每个都超级实用，关系到我们每个人的健康，赶快来了解一下吧！\n\n1.就医篇\n\n1.首次就诊不用挂专家号\n首诊主要是询问病史、开具相关检验检查，挂普通号就可以。\n\n2.不管服用任何药物，都要忌吸烟\n烟中含有的盐碱会加快肝脏降解药物的速度，导致血液中药物浓度下降。\n\n3.乳腺增生不用治\n一个体检下来，10个女性8个有"乳腺增生"问题，绝大多数是良性的，注意定期复查即可。\n\n4.看到治疗宫颈糜烂的医院赶紧跑\n"宫颈糜烂"这个名称已经被取消，如果被诊断为这个东西，说明医院或者医生不靠谱。\n\n5.得糖尿病不是因为吃糖多\nⅠ型糖尿病的主因是遗传，Ⅱ型糖尿病的主要原因是肥胖。\n\n6.抓伤咬伤后注射狂犬疫苗非常重要\n狂犬病的致死率几乎是100%，有效的预防手段是注射疫苗，哪怕没有出血。\n\n7.别重复用药\n以感冒药为例，多数感冒药都含有解热镇痛的化学成分乙酰氨基酚，如同时服用多种感冒药，或是中西药物混合使用，总剂量会在不知不觉中超量，造成肝脏受损。\n\n8.体检非常重要\n越早诊断和开始治疗，效果越好。\n\n9.打鼾其实是病\n严重的还会引起呼吸暂停，甚至有些人还会在睡梦中死亡。\n\n10.感冒不一定要吃药，但要小心并发症\n感冒不一定要吃药，但若超过7天，病情还不好转，应及时寻求医生的帮助。\n\n11.腹泻不用禁食\n传统的腹泻治疗方法，主张让孩子禁食一段时间。其实这样不利于身体的营养补充。\n\n12.不要往伤口上抹任何粉状的东西\n不管是割伤还是烫伤，受伤后在伤口表面涂抹的粉状物会造成严重的疤痕增生。\n\n13.抗生素一定要遵医嘱足量、足时使用\n细菌耐药性的产生，就是因为细菌不能被抗生素完全杀死，残留下部分耐药性强的成为优势菌群。\n\n14.流鼻血仰头没用\n仰头会导致血液被吞下，而产生不适感或呕吐。出血量大时，还容易吸入气管及肺内。\n\n15.不要相信任何能快速治愈严重皮肤病的方法\n对于银屑病、白癜风等疾病，病因主要是自体免疫的异常。所谓偏方几乎都使用了重金属毒剂。这类方法确实可缓解症状，但肾脏和肝脏也会受影响。\n\n16.脚气是一个全身性疾病\n只要脚上有可见的感染灶，一般全身都会有真菌分布，要根治需配合口服抗真菌药。',
          publishTime: '2024-03-20',
          isPaid: true,
          price: 9.9
        },
        1002: {
          id: 1002,
          title: '关爱生命健康，守护药品安全——安全用药常识',
          category: '药品相关',
          content: '药品是一把"双刃剑"，既能救人，又能害人。生活中我们经常和药品打交道，知道药品如果能够"对症下药"就能够救人，反之就有可能害人，所以说药品本身就是一把"双刃剑"，在生活中如何能够根据病情，真正做到"对症下药"，掌握一些用药的常识对我们来说是非常有必要的。\n\n一、哪些药物不能用热水服用\n1.助消化类 ，如多酶片、酵母片等，此类药中的酶是活性蛋白质，遇热后即凝固变性而失去应有的催化剂作用。\n2.维生素C ，它是水溶性制剂，不稳定，遇热后易还原而失去药效。\n3.止咳糖浆类，止咳药溶解在糖浆里，覆盖在发炎的咽部粘膜表面，形成保护性的薄膜，能减轻粘膜炎症反应，阻断刺激而缓解咳嗽。若用热水冲服会稀释糖浆，降低粘膜稠度，不能生成保护性薄膜。\n\n二、家庭药箱配置的误区\n误区一：选药不当，药店一般出售保健品、非处方药品、处方药品三大类。非处方药是指那些无需持医生处方，市民可直接从药店购买的药物，其外包装盒上有"OTC"标志；如果药品外包装盒上无OTC标志，且标明是"药准字号"，则这类药属于处方药；保健品包装盒上则是"食字号"标志。"家庭药箱"应尽量选择安全性高的OTC药品。某些导购员推荐一些不合适的药品，市民购买时一定要注意识别。\n\n误区二：购买过量。有些市民为图方便，在药店一次性购买许多药。但太多的药品用不完容易过期，服药过量或不当可能会造成自身器官损害或浪费。\n\n误区三：没有及时清理。大部分家庭没有定期清理药箱的习惯，有的家庭还怕浪费，认为服用外观无异样的过期药对健康没损害。\n\n注意：许多药由于稳定性较差，易受光线、温度、湿度等影响，吃剩的药品如未在合适条件下存放，容易出现爆裂、发霉、斑点、自融、水化等现象，这种变质药不能吃。还有些药从表面上看不出异样，但也不能服用，因为药品一旦过了有效期，药效会降低，毒性则会增高。\n\n三、酒后服药\n酒的主要成分是乙醇，能与许多药物发生相互作用，应用药物时饮酒，将会引起药效降低或增加毒性反应，严重时甚至可以危及生命，应当引起大家注意。',
          publishTime: '2024-03-18',
          isPaid: true,
          price: 12.9
        },
        1003: {
          id: 1003,
          title: '中医基础知识大全',
          category: '中医相关',
          content: '中医基础知识大全\n\n1．有机整体的中心是：五脏。\n2．有机整体的主宰是：心。\n3．阳中之阳的时间是：上午。\n4．阴中之阴的时间是：前半夜。\n5．阳中之阴的时间是：下午。\n6．阳中之阳的时间是：上午。\n7．说明阴阳互根的是：阴在内，阳之守也。\n8．说明对立制约的是：动极者镇之以静。\n9．说明阴阳互根的是：阴中求阳。\n10．说明阴阳转化的是：热极生寒。\n11．称"阳中之阳"的脏是：心。\n12．称"阴中之阳"的脏是：肝。\n13．称"阴中之阴"的脏是：肾。\n14．称"阳中之阴"的脏是：肺。\n15．阴偏胜所致证候是：实寒证。\n16．阴偏衰所致证候是：虚热证。\n17．阳偏胜所致证候是：实热证。\n18．阳偏衰所致证候是：虚寒证。\n19．根据阴阳互根确定的治法是：阳中求阴。\n20．适用于阳偏衰的治法是：阴病治阳。\n21．根据阴阳对立制约确定的治法是：热者寒之。\n22．适用于阳偏胜的治法是：热者寒之。\n23．"木"的特性是：曲直。\n24．"水"的特性是：润下。\n25．属于"金"的音是：商音。\n26．属于"水"的音是：羽音。\n27．木的"所不胜"之行是：金。\n28．水的"所胜"之行是：火。\n29．金的子行为：水。\n30．火的母行为：木。\n31．木的"所不胜"之"子"是：水。\n32．木的"母"之"所胜"是：火。\n33．肝病传脾的是：相乘。\n34．肝病传心的是：母病及子。\n35．肺病及肾是：母病及子。\n36．木火刑金是：相侮。\n37．"见肝之病，知肝传脾"属于：相乘。\n38．"水气凌心"属于：相乘。\n39．喜胜：悲。\n40．恐胜：喜。\n41．属于"火"的是：喜。\n42．属于"金"的是：悲。\n43．属于"水"的是：耳。\n44．属于"土"的是：口。\n45．属于"水"的是：咸。\n46．属于"木"的是：酸。\n47．属于"水"的是：黑。\n48．属于"金"的是：白。\n49．"君主之官"指：心。\n50．"将军之官"指：肝。\n51．"生之本"指：心。\n52．"罢极之本"指：肝。\n53．"气之根"是指：肾。\n54．"气之主"是指：肺。\n55．"先天之本"是指：肾。\n56．"后天之本"是指：脾。\n57．"生气之源"指：脾。\n58．"主气之枢"指：肺。\n59．"生痰之源"指：脾。\n60．"贮痰之器"指：肺。\n61．主行血的是：心。\n62．主统血的是：脾。\n63．朝百脉的是：肺。\n64．主生血的是：脾。\n65．通调水道的是：肺。\n66．运化水液的是：脾。\n67．主行血的是：心。',
          publishTime: '2024-03-15',
          isPaid: false
        },
        1004: {
          id: 1004,
          title: '脾胃不好的人，少吃这3类水果',
          category: '饮食相关',
          content: '水果是公认的健康食物，不仅能满足口腹之欲，还可以增加维生素、矿物质、膳食纤维等营养物质的摄入。\n但是对于脾胃不好的人来说，吃某些水果反而会加重脾胃负担。\n脾胃不好少吃3种水果\n广州中医药大学第一附属医院脾胃病科主任医师李常青表示，对于胃不好的人来说，并非所有水果都适合食用。下面几种水果吃多了，可能让脾胃越来越差。\n1 酸度高的\n酸味水果含有单宁、原花青素等多酚类物质，以及一定量的蛋白酶，均能引起蛋白质凝固，如果胃中黏液分泌不足，可能让消化道黏膜表面受损。\n过多食用百香果、山楂等酸味水果，易引起肠胃不适，影响正常消化吸收，甚至加重胃痛、烧心等不适症状。建议选择较"温和"的苹果、香蕉、桃子、草莓等水果。\n2 寒凉属性的\n胃喜温恶寒，脾胃虚寒的人尤其要注意避免过多摄入寒凉食物。\n西瓜、柿子等寒凉属性的水果容易损伤脾胃阳气，进一步降低脾胃的运化功能，吃多了可能会出现消化不良、腹痛、腹泻等症状。\n3 反季节水果\n反季节水果往往是通过特殊的种植技术或在大棚环境中培育出来的。它们不仅在口感和营养成分上与应季水果有差异，为了保鲜和运输，可能还会使用一些化学药剂。\n胃不好的人，肠胃功能相对弱，对于这些 "特殊成分" 可能难以适应和消化，吃多了容易加重不适。\n水果不同吃法各有利弊\n《中国居民膳食指南（2022）》推荐成年人每日食用水果200~350克（一般为1~2个拳头大小），建议每天至少1~2种水果。\n对大多数人来说，直接吃新鲜水果是最佳选择。但有些人觉得直接吃麻烦，喜欢榨成汁喝或吃水果干，这些"花式"吃法对水果的营养价值有什么影响？\n榨汁喝 营养损失大\n水果榨汁之后，有两种营养素损失很大：\n维生素C，这种营养素比较"娇气"，怕热怕氧气，榨汁过程中易发生氧化。\n膳食纤维，原因在于绝大多数水果榨汁后，水果残渣都被过滤掉了，而膳食纤维主要集中在这些水果残渣中。\n水果榨汁过程中，细胞壁会被破坏，其中的果糖、葡萄糖等被释放出来，这些糖在人体内的吸收率显著提高，更容易进入人体参与代谢。即使果汁中没有添加糖，喝了之后也会导致血糖快速升高。\n水果干 保留大部分营养\n水果干保留了水果中的大部分营养，只有一些怕热的营养素被破坏，比如维生素C。美国《营养学会杂志》刊登的一项研究发现，水果干的升糖指数并不高，对消化道的刺激比水果小，且饱腹感较强。\n需要注意的是，水果干热量很高，所以要严格限量。每天吃1~2次，每次1小把即可。\n水果干不能替代新鲜水果，而且要分清"水果干"和"果脯""蜜饯"的区别。果脯和蜜饯会添加大量糖，对健康没啥好处。\n做熟吃 两类水果很适合\n水果加热后会变软易消化，虽然会流失其中不耐热的水溶性营养素，但是大部分矿物质、膳食纤维、糖类等营养成分被保留了下来。这两种水果很适合熟吃：\n蔫了的水果。可以切块放入半锅水中，中火慢炖，汤和果实一起食用，润燥又润肠道。',
          publishTime: '2024-03-22',
          isPaid: true,
          price: 8.9
        },
        1005: {
          id: 1005,
          title: '食品药品安全知识普及',
          category: '饮食相关',
          content: '一、什么是合理用药?\n世界卫生组织对合理用药要求是，药物适合患者临床需要、药物的剂量，符合患者个体需要、疗程足够和药价。具体标准是，\n1.处方的药应为适宜的药物。\n2.在适宜的时间，以公众能支付的价格保证药物供应。\n3.正确地调剂处方。\n4.以准确的剂量，正确的用法和疗程服用药物。\n5.确保药物质量安全有效。\n二、不同的人服用同样的药，为什么有的人有不良反应，有的人没有不良反应?\n主要是因为人与人之间对药品不良反应的敏感性方面有较大的个体差异。\n三、哪些药可能影响儿童的健康?\n已有资料表明，链霉素、卡那霉素、庆大霉素有可能损害儿童的听神经引起耳聋，多黏菌素、去甲肾上腺素能引起儿童的肾脏损伤，胃复安能引起一些儿童的脑损伤，四环素、氟哌酸等药物能影响幼儿牙齿、骨骼的发育等，因此，儿童用药的选择应特别慎重。\n四、患者发现可疑药品不良反应该怎么办?\n患者发现可疑药品不良反应，立即停止服用，去医院就诊。向医药专业人员咨询，可疑症状确属药品不良反应，今后应避免再服用同样药物。根据《药品不良反应监测管理办法》规定，个人发现药品可疑不良反应，应向所在省、自治区、直辖市药品不良反应监测中心或药品监督管理局报告。\n五、药物依赖性分为哪几类?\n世界卫生组织将药物依赖性分为精神依赖性和身体依赖性。精神依赖性又称心理依赖性。凡能引起令人愉快意识状态的任何药物即可引起精神依赖性，精神依赖者为得到欣快感而不得不定期或连续使用某些药物。身体依赖性也称生理依赖性。用药者反复地应用某种药物造成一种适应状态，停药后产生戒断症状，使人非常痛苦，甚至危及生命。能引起依赖性的药物常兼有精神依赖性和身体依赖性，阿片类和催眠镇痛药在反复用药过程中，先产生精神依赖性，后产生身体依赖性。可卡因、苯丙胺类中枢兴奋药主要引起精神依赖性，但大剂量使用也会产生身体依赖性。少数药物如致幻剂只产生精神依赖性而无身体依赖性。\n如何判别伪劣食品?\n伪劣食品犹如过街老鼠，人人喊打。但人们在日常购物时却难以识别。《伪劣食品防范"七字法"》，以通俗易懂易记的方式引导消费者强化食品安全自我防范，以期使伪劣食品因缺乏市场而退出市场。防范"七字法"：即防"艳、白、反、长、散、低、小"。\n一防"艳"。对颜色过分艳丽的食品要提防，如目前上市的草莓象蜡果一样又大又红又亮、咸菜梗亮黄诱人、瓶装的蕨菜鲜绿不褪色等，要留个心眼，是不是在添加色素上有问题?\n二防"白"。凡是食品呈不正常不自然的白色，十有八九会有漂白剂、增白剂、面粉处理剂等化学品的危害。\n三防"长"。尽量少吃保质期过长的食品，3℃贮藏的包装熟肉禽类产品采用巴氏杀菌的，保质期一般为7—30天。\n四防"反"。就是防反自然生长的食物，如果食用过多可能对身体产生影响。\n五防"小"。要提防小作坊式加工企业的产品，这类企业的食品平均抽样合格率最低，触目惊心的食品安全事件往往在这些企业出现。\n六防"低"。"低"是指在价格上明显低于一般价格水平的食品，价格太低的食品大多有"猫腻"。\n七防"散"。散就是散装食品，有些集贸市场销售的散装豆制品、散装熟食、酱菜等可能来自地下加工厂。\n一、 什么是食品质量安全?\n食品质量安全是指食品质量状况对食用者健康、安全的保证程度。包括三方面内容：\n一是食品的污染导致的质量安全问题。例：生物性污染、化学性污染、物理性污染等。\n二是食品工业技术发展所带来的质量安全问题。如：食品添加剂、食品生产配剂、介质以及辐射食品、转基因食品等。\n三是滥用食品标识。例：伪造食品标识、缺少警示说明、虚假标注食品功能或成分、缺少中文食品标识(进口食品)等。',
          publishTime: '2024-03-21',
          isPaid: true,
          price: 10.9
        },
        1006: {
          id: 1006,
          title: '普及食品安全常识',
          category: '饮食相关',
          content: '把好食品安全关吧！\n\n1、培养饮食安全习惯\n1.养成良好的饮食习惯，饭前要洗手，洗干净、煮熟了的食物才能食用。2.一日三餐要吃好，定时定量进食，切忌暴饮暴食。3.不吃生冷食物、不吃不洁瓜果、不吃腐败变质食物、不吃冷菜、不喝生水、不吃垃圾食品。4.用餐餐具洗净、消毒，不用不洁容器盛装食品，不乱扔垃圾防止蚊蝇孳生。5.剧烈运动后不要急于吃食物或喝水。\n\n2、引起食物中毒的常见因素\n1.在食物危险温度带（5℃~60℃，尤其是37℃~42℃区间）贮藏食物。2.不适当地冷却/加热/解冻食物。3.从烹调到食用的时间间隔太长，使细菌有足够的繁殖时间。4.生熟食品交叉污染。5.使用受污染的生食品或原辅料。6.已加工的食物被污染 。7.厨房设备、餐具等清洗、消毒的方法不正确。8.由病原携带者或感染者加工食品。\n\n3、食物中毒应急措施\n食物中毒的应急措施主要保包括催吐、中和解毒、洗胃和导泻等。催吐可排出残留在胃内的毒物，适用于意识清醒且没有呕吐患者，催吐时可以用手指或筷子刺激舌根部，促使胃内容物呕出。中和解毒是指在中毒后立即口服蛋清、牛奶等，中和沉淀有毒物质。洗胃是指在医院内，用洗胃机或者用人工方法排出毒物，可以清除胃内残留的有毒物质，减少毒素的吸收。对于已经进入肠道的毒物，可以使用导泻药来促进毒物的排出。但导泻药不能过度使用，以免引起身体脱水或肠道损伤。应在医生的指导下使用导泻药。此外，食物中毒后，患者可能会出现呕吐、腹泻等症状，导致水电解质失衡。患者应多喝水、淡盐水或补充电解质溶液，以维持水电解质平衡。中毒症状严重时，应及时寻求医疗帮助，拨打120急救电话或前往最近的医疗机构就诊。\n\n4、预防食物中毒的措施\n防范食物中毒，需要从方方面面进行注意。第一，食物要清洁，生熟食品要分开。第二，生鲜食物要彻底加热，避免食用未经充分烹饪的食品，如生鱼片、生鸡蛋、生奶酪等。第三，检查食品保质期，避免食用过期食品，不吃霉变食物，不吃隔夜菜。第四，选择新鲜安全的食物，避免购买来源不明的食品，避免食用不明来历的野山菌。第五，保持良好个人卫生习惯，勤洗手，特别是在处理食物之前和上厕所之后。',
          publishTime: '2024-03-23',
          isPaid: true,
          price: 9.9
        },
        1007: {
          id: 1007,
          title: '建立科学饮食文化',
          category: '饮食相关',
          content: '以及春季防过敏这些误区要警惕，"春季万物复苏，过敏原比较多，比如柏树、杨树、梧桐、桉树，这些树种产生的花粉颗粒比较小，而且飘得比较远，所以容易造成过敏。"在3月19日国家卫生健康委召开的例行新闻发布会上，北京地坛医院主任医师蒋荣猛提醒公众，易过敏的人群，外出时要尽量避开花粉高发时段；如果有条件，应根据当地的花粉监测数据选择出行。\n\n什么样的人群容易花粉过敏？针对过敏症状有哪些预防和治疗的措施？此外，春季还有哪些健康问题应注意预防？与会专家进行了现场解读。\n\n"有过敏家族史的，如过敏性哮喘、过敏性鼻炎或湿疹人群容易发生过敏。此外，免疫功能不太成熟的儿童和青少年也容易过敏。"蒋荣猛说，压力较大导致机体免疫功能紊乱或者经常在过敏原环境中久待都容易使人发生过敏。\n\n过敏是可以预防的。蒋荣猛表示，一些过敏严重的人群可以在医生指导下在花粉高发季之前使用预防性药物。另外，要通过规律作息、良好睡眠、避免摄入辛辣刺激食物或酒精等降低过敏几率。\n\n在花粉高发时段，蒋荣猛建议，公众出行采取佩戴口罩、护目镜，穿着长袖衣等防护措施，外出后用生理盐水清洗鼻腔；关闭居室门窗，并对家里的床单、被褥、窗帘、地毯等进行定期清洁。\n\n针对春季过敏治疗的一些误区，蒋荣猛提醒，春季过敏很难做到完全根治，不要相信打一针就能把过敏完全治好的药物广告。\n\n"有人认为抗过敏药物会上瘾也是没有科学依据的。"蒋荣猛说，当前使用的抗过敏药包括抗组胺药、鼻用激素，均不会引发上瘾，但长期使用会出现嗜睡等副作用。\n\n"过敏者应在医生指导下制定一个长期的管理计划，通过环境控制、生活方式改变、恰当的药物治疗、脱敏治疗等措施，症状可逐渐好转。"蒋荣猛说，一些过敏者感觉好了就停药是不可取的，因为一旦停药可能会引起过敏症状的反复甚至加重。',
          publishTime: '2024-03-24',
          isPaid: true,
          price: 11.9
        },
        1008: {
          id: 1008,
          title: '如何辨别每天吃的食物是否安全？',
          category: '饮食相关',
          content: '药品追溯码医保应用的五问五答，近日，国家医保局通过药品追溯码核查有关问题引发关注。药品追溯码是什么？药品追溯码被重复扫码意味着什么？药品追溯码对保障医保基金安全有哪些作用？药品追溯码怎么用？小编整理了社会普遍关心的几个问题，为大家解答。\n\n问题1：药品追溯码是什么？\n答：药品追溯码是药品的"电子身份证"，通常由一系列数字、字母和（或）符号组成，标识在药品包装盒的显著位置，是每一盒药品从生产出厂时就被赋予的唯一身份标签。若在流通过程中药品追溯码重复出现，则该药品就可能是"回流药"、假药或是被串换销售。\n\n药品追溯码主要有三个特点：一是具有唯一性。每一盒药品都有唯一的追溯码，不同盒药的追溯码各不相同；正如每个人都有唯一的身份证号码，不同人的身份证号码各不相同。二是应用于"最小包装单元"。药品的每个"最小包装单元"都有各自唯一的追溯码，确保每个"最小包装单元"药品的生产、销售路径都可查询、可追溯。三是具有大数据效应。目前，医保部门正在大力推进药品追溯码采集、应用工作。医保部门采集的追溯码数据越全面、越丰富、越完整，追溯码发挥的效用就越大。\n\n问题2：如何通过追溯码发现"回流药"、药品被"串换"销售等线索，保护医保基金安全？\n答：按照有关药品和医保管理规定，一盒药品卖给患者后，就不能再被卖给别的患者，只能卖一次，因此，一盒药品的追溯码，只应有一次被最终销售扫码的记录。若存在多次终端结算扫码记录，则该药品就可能是"回流药"或是被串换销售。\n\n一些不法分子使用医保基金购买药品后，不是自己使用，而是转手倒卖，将药品二次销售甚至多次销售，以骗取医保基金。这种经倒卖的药品被称为"回流药"。',
          publishTime: '2024-03-25',
          isPaid: true,
          price: 10.9
        },
        1009: {
          id: 1009,
          title: '中医基础知识入门自学指南',
          category: '中医相关',
          content: '中医，作为中国传统医学的瑰宝，其理论体系博大精深，涵盖了整体观念、辩证论治、阴阳五行等多个方面。本文旨在为初学者提供一份中医基础知识入门自学指南，帮助读者快速了解中医的基本框架和核心概念。\n\n1.整体观念与辩证论治\n整体观念：中医强调人体是一个有机整体，五脏六腑、四肢百骸通过经络相互关联，并与外界环境密切相关。\n辩证论治：中医通过四诊（望、闻、问、切）收集症状，分析病因、病性、病位，确定证候，进而制定个性化的治疗方案。\n\n2.阴阳学说\n阴阳定义：阴阳是对自然界相互关联的事物或现象对立双方属性的概括，具有对立统一的内涵。\n阴阳关系：包括对立制约、互根互用、交感互藏、消长转化等。\n应用实例：如"阳病治阴"、"阴病治阳"等治疗原则。\n\n3.五行学说\n五行定义：金、木、水、火、土五种基本物质及其运动变化。\n相生相克：五行之间存在相生（如木生火）和相克（如木克土）的关系。\n应用实例：如滋水涵木、益火补土等治法。\n\n4.脏腑经络\n脏腑功能：五脏（心、肝、脾、肺、肾）和六腑（胆、胃、小肠、大肠、膀胱、三焦）各有其独特的生理功能。\n经络系统：经络是气血运行的通道，联系脏腑与体表，具有沟通内外、运行气血、调节平衡的作用。\n\n5.病因病机\n病因：包括外感六淫（风、寒、暑、湿、燥、火）和内伤七情（喜、怒、忧、思、悲、恐、惊）等。\n病机：疾病发生、发展、变化的机制，如正邪相争、气血失调等。\n\n6.治疗方法\n中药：根据药物的性味归经，采用四气五味、升降浮沉等理论进行配伍。\n针灸：通过针刺或艾灸等刺激经络穴位，达到调和气血、疏通经络、扶正祛邪的目的。\n推拿按摩：运用手法作用于人体体表特定部位，以调节机体生理、病理状况。',
          publishTime: '2024-03-26',
          isPaid: true,
          price: 15.9
        },
        1010: {
          id: 1010,
          title: '医学小常识（一）：基础生理指标解读',
          category: '就医相关',
          content: '在日常生活中，我们经常会接触到各种生理指标，如血压、血糖、心率等。了解这些指标的正常范围和意义，对于维护健康非常重要。本文将为您详细介绍一些基础生理指标的解读方法。\n\n1. 血压\n正常范围：\n- 收缩压（高压）：90-140 mmHg\n- 舒张压（低压）：60-90 mmHg\n\n血压异常可能提示：\n- 高血压：收缩压≥140 mmHg或舒张压≥90 mmHg\n- 低血压：收缩压<90 mmHg或舒张压<60 mmHg\n\n2. 心率\n正常范围：60-100次/分钟\n\n心率异常可能提示：\n- 心动过速：>100次/分钟\n- 心动过缓：<60次/分钟\n\n3. 体温\n正常范围：36.3-37.2℃\n\n体温异常可能提示：\n- 发热：>37.3℃\n- 低体温：<36.3℃\n\n4. 呼吸频率\n正常范围：12-20次/分钟\n\n呼吸频率异常可能提示：\n- 呼吸急促：>20次/分钟\n- 呼吸缓慢：<12次/分钟\n\n5. 血糖\n正常范围：\n- 空腹血糖：3.9-6.1 mmol/L\n- 餐后2小时血糖：<7.8 mmol/L\n\n血糖异常可能提示：\n- 糖尿病：空腹血糖≥7.0 mmol/L或餐后2小时血糖≥11.1 mmol/L\n- 低血糖：<3.9 mmol/L\n\n6. 血氧饱和度\n正常范围：95%-100%\n\n血氧饱和度异常可能提示：\n- 低氧血症：<95%\n- 严重低氧：<90%\n\n7. 体重指数（BMI）\n计算公式：体重(kg) / 身高(m)²\n\n正常范围：18.5-24.9\n\nBMI异常可能提示：\n- 偏瘦：<18.5\n- 超重：25-29.9\n- 肥胖：≥30\n\n8. 注意事项\n1. 测量时间：建议在早晨起床后、空腹状态下测量\n2. 测量环境：保持安静、舒适的环境\n3. 测量工具：使用经过认证的医疗设备\n4. 记录方式：建议定期记录，观察变化趋势\n5. 异常处理：发现异常及时就医\n\n9. 定期体检建议\n1. 18-40岁：每2-3年体检一次\n2. 40-60岁：每年体检一次\n3. 60岁以上：每半年体检一次\n4. 有慢性病史者：遵医嘱定期复查\n\n10. 健康生活方式建议\n1. 均衡饮食：控制总热量，增加蔬果摄入\n2. 适量运动：每周至少150分钟中等强度运动\n3. 充足睡眠：保证7-8小时睡眠时间\n4. 戒烟限酒：避免吸烟，限制酒精摄入\n5. 心理平衡：保持良好心态，适当减压\n\n通过了解这些基础生理指标，我们可以更好地监测自己的健康状况，及时发现异常，采取相应的预防和治疗措施。记住，这些指标仅供参考，具体诊断和治疗方案请遵医嘱。',
          publishTime: '2024-03-27',
          isPaid: true,
          price: 12.9
        },
        1011: {
          id: 1011,
          title: '医学小常识（二）：健康指标与体重管理',
          category: '就医相关',
          content: '体重管理是健康管理的重要组成部分，合理的体重不仅关系到外表美观，更与多种慢性疾病的预防密切相关。本文将详细介绍健康指标与体重管理的相关知识。\n\n1. 体重相关指标\n1.1 体重指数（BMI）\n- 计算公式：体重(kg) / 身高(m)²\n- 正常范围：18.5-24.9\n- 超重：25-29.9\n- 肥胖：≥30\n\n1.2 腰围\n- 男性正常范围：<90cm\n- 女性正常范围：<85cm\n- 超过正常范围提示中心性肥胖\n\n1.3 体脂率\n- 男性正常范围：15%-20%\n- 女性正常范围：20%-25%\n- 超过正常范围提示体脂过多\n\n2. 体重管理的目标\n2.1 短期目标\n- 每周减重0.5-1kg\n- 保持体重稳定\n- 改善身体成分\n\n2.2 长期目标\n- 达到并维持理想体重\n- 预防慢性疾病\n- 提高生活质量\n\n3. 健康减重方法\n3.1 饮食调整\n- 控制总热量摄入\n- 增加蛋白质比例\n- 减少精制碳水化合物\n- 增加膳食纤维\n- 控制脂肪摄入\n\n3.2 运动计划\n- 有氧运动：每周3-5次，每次30-60分钟\n- 力量训练：每周2-3次，每次20-30分钟\n- 柔韧性训练：每周2-3次，每次15-20分钟\n\n3.3 生活方式调整\n- 规律作息\n- 充足睡眠\n- 压力管理\n- 戒烟限酒\n\n4. 体重管理的误区\n4.1 常见误区\n- 快速减重\n- 节食减肥\n- 单一食物减肥\n- 过度运动\n- 依赖减肥药\n\n4.2 正确认识\n- 减重是一个渐进的过程\n- 需要综合方案\n- 要注重营养均衡\n- 运动要适度\n- 药物辅助需遵医嘱\n\n5. 体重管理的监测\n5.1 定期测量\n- 体重：每周1-2次\n- 腰围：每月1次\n- 体脂率：每月1次\n\n5.2 记录方式\n- 使用体重管理APP\n- 建立健康档案\n- 记录饮食日记\n- 记录运动日志\n\n6. 特殊情况处理\n6.1 平台期\n- 调整运动强度\n- 改变运动方式\n- 调整饮食结构\n- 保持耐心\n\n6.2 体重反弹\n- 分析原因\n- 调整方案\n- 加强监督\n- 寻求专业帮助\n\n7. 健康饮食建议\n7.1 食物选择\n- 优质蛋白质：鱼、禽、蛋、豆制品\n- 复合碳水化合物：全谷物、薯类\n- 健康脂肪：坚果、橄榄油\n- 新鲜蔬果：每天500g以上\n\n7.2 饮食原则\n- 定时定量\n- 细嚼慢咽\n- 少食多餐\n- 控制总热量\n\n8. 运动建议\n8.1 有氧运动\n- 快走\n- 慢跑\n- 游泳\n- 骑自行车\n\n8.2 力量训练\n- 哑铃训练\n- 弹力带训练\n- 自重训练\n\n8.3 柔韧性训练\n- 瑜伽\n- 普拉提\n- 拉伸运动\n\n9. 心理调适\n9.1 建立正确认知\n- 接受自己\n- 设定合理目标\n- 保持积极心态\n\n9.2 压力管理\n- 规律作息\n- 适当放松\n- 寻求支持\n\n10. 长期维持\n10.1 建立健康习惯\n- 规律运动\n- 均衡饮食\n- 充足睡眠\n\n10.2 定期评估\n- 体重变化\n- 身体成分\n- 健康状况\n\n通过科学的方法进行体重管理，不仅可以改善外观，更重要的是可以预防多种慢性疾病，提高生活质量。记住，体重管理是一个长期的过程，需要耐心和毅力，同时也要注意方法的科学性和安全性。',
          publishTime: '2024-03-28',
          isPaid: true,
          price: 12.9
        },
        1012: {
          id: 1012,
          title: '医学小常识（三）：日常健康指标与检查',
          category: '就医相关',
          content: '在日常生活中，我们经常会接触到各种健康指标和检查项目。了解这些指标和检查的意义，对于维护健康非常重要。本文将为您详细介绍一些常见的健康指标和检查项目。\n\n1. 基础生理指标\n1.1 血压\n- 正常范围：收缩压90-140mmHg，舒张压60-90mmHg\n- 测量时间：建议早晨起床后、空腹状态下测量\n- 注意事项：保持安静、舒适的环境\n\n1.2 心率\n- 正常范围：60-100次/分钟\n- 测量方法：静息状态下测量\n- 影响因素：年龄、运动、情绪等\n\n1.3 体温\n- 正常范围：36.3-37.2℃\n- 测量部位：腋下、口腔、耳道\n- 异常提示：发热、低体温\n\n2. 血液检查\n2.1 血常规\n- 红细胞计数：反映贫血情况\n- 白细胞计数：反映免疫功能\n- 血小板计数：反映凝血功能\n\n2.2 生化检查\n- 血糖：反映糖代谢情况\n- 血脂：反映脂代谢情况\n- 肝功能：反映肝脏功能\n- 肾功能：反映肾脏功能\n\n3. 影像学检查\n3.1 X线检查\n- 胸部X线：检查肺部疾病\n- 骨骼X线：检查骨骼疾病\n\n3.2 超声检查\n- 腹部超声：检查腹部脏器\n- 心脏超声：检查心脏功能\n\n3.3 CT检查\n- 头部CT：检查脑部疾病\n- 胸部CT：检查肺部疾病\n\n4. 心电图检查\n4.1 常规心电图\n- 检查心脏电活动\n- 发现心律失常\n- 诊断心肌缺血\n\n4.2 动态心电图\n- 24小时监测\n- 发现偶发心律失常\n- 评估治疗效果\n\n5. 内镜检查\n5.1 胃镜检查\n- 检查食管、胃、十二指肠\n- 发现消化系统疾病\n- 进行活检\n\n5.2 肠镜检查\n- 检查大肠、直肠\n- 发现肠道疾病\n- 进行息肉切除\n\n6. 骨密度检查\n6.1 检查意义\n- 评估骨质疏松风险\n- 监测骨量变化\n- 指导预防治疗\n\n6.2 检查方法\n- 双能X线吸收法\n- 定量超声法\n\n7. 肿瘤标志物检查\n7.1 常见项目\n- AFP：肝癌标志物\n- CEA：消化道肿瘤标志物\n- PSA：前列腺癌标志物\n\n7.2 检查意义\n- 辅助诊断\n- 监测复发\n- 评估预后\n\n8. 甲状腺功能检查\n8.1 检查项目\n- TSH：促甲状腺激素\n- T3、T4：甲状腺激素\n- 甲状腺抗体\n\n8.2 检查意义\n- 诊断甲状腺疾病\n- 评估治疗效果\n- 监测病情变化\n\n9. 检查注意事项\n9.1 检查前准备\n- 空腹要求\n- 药物停用\n- 检查时间\n\n9.2 检查后护理\n- 观察反应\n- 及时报告异常\n- 遵医嘱处理\n\n10. 定期体检建议\n10.1 体检频率\n- 18-40岁：每2-3年\n- 40-60岁：每年\n- 60岁以上：每半年\n\n10.2 体检项目\n- 基础检查\n- 专科检查\n- 特殊检查\n\n通过了解这些健康指标和检查项目，我们可以更好地监测自己的健康状况，及时发现异常，采取相应的预防和治疗措施。记住，这些指标和检查结果仅供参考，具体诊断和治疗方案请遵医嘱。',
          publishTime: '2024-03-29',
          isPaid: true,
          price: 12.9
        },
        1013: {
          id: 1013,
          title: '老年人健康指南：科学养生与疾病预防',
          category: '老年人健康',
          content: '随着年龄的增长，老年人的身体机能逐渐下降，更容易受到各种疾病的困扰。因此，科学的养生保健和疾病预防对老年人来说尤为重要。本文将为您详细介绍老年人健康管理的各个方面。\n\n1. 老年人常见健康问题\n1.1 慢性疾病\n- 高血压\n- 糖尿病\n- 冠心病\n- 骨质疏松\n- 关节炎\n\n1.2 认知功能\n- 记忆力减退\n- 注意力不集中\n- 反应速度下降\n\n1.3 心理问题\n- 孤独感\n- 焦虑\n- 抑郁\n\n2. 健康生活方式\n2.1 合理饮食\n- 控制总热量\n- 增加优质蛋白\n- 补充钙质\n- 多摄入膳食纤维\n- 限制盐分和糖分\n\n2.2 适量运动\n- 有氧运动：散步、太极拳\n- 力量训练：轻量哑铃\n- 柔韧性训练：瑜伽、拉伸\n- 平衡训练：单腿站立\n\n2.3 充足睡眠\n- 保持规律作息\n- 创造良好睡眠环境\n- 避免睡前刺激\n- 适当午休\n\n3. 疾病预防\n3.1 定期体检\n- 基础检查：血压、血糖、血脂\n- 专科检查：心电图、骨密度\n- 肿瘤筛查：胃肠镜、B超\n\n3.2 疫苗接种\n- 流感疫苗\n- 肺炎疫苗\n- 带状疱疹疫苗\n\n3.3 慢性病管理\n- 规律服药\n- 定期复查\n- 监测指标\n- 及时调整治疗方案\n\n4. 心理健康\n4.1 保持社交\n- 参加社区活动\n- 与家人朋友保持联系\n- 培养兴趣爱好\n\n4.2 情绪管理\n- 保持乐观心态\n- 学会放松\n- 适当倾诉\n- 寻求专业帮助\n\n5. 安全防护\n5.1 居家安全\n- 防滑措施\n- 照明充足\n- 扶手安装\n- 清除障碍物\n\n5.2 用药安全\n- 遵医嘱用药\n- 定期整理药箱\n- 注意药物相互作用\n- 避免重复用药\n\n6. 营养补充\n6.1 必需营养素\n- 蛋白质：鱼、禽、蛋、豆制品\n- 钙质：奶制品、豆制品\n- 维生素D：晒太阳、深海鱼\n- 膳食纤维：全谷物、蔬菜水果\n\n6.2 营养补充剂\n- 根据医嘱服用\n- 注意剂量\n- 避免过量\n\n7. 运动建议\n7.1 运动原则\n- 循序渐进\n- 量力而行\n- 持之以恒\n- 注意安全\n\n7.2 推荐运动\n- 散步：每天30-60分钟\n- 太极拳：每周3-5次\n- 游泳：每周2-3次\n- 瑜伽：每周2-3次\n\n8. 就医指南\n8.1 就医准备\n- 整理病史资料\n- 记录症状变化\n- 准备问题清单\n\n8.2 用药管理\n- 建立用药记录\n- 按时服药\n- 注意不良反应\n\n9. 紧急情况处理\n9.1 常见急症\n- 胸痛\n- 呼吸困难\n- 意识改变\n- 严重外伤\n\n9.2 应对措施\n- 保持冷静\n- 及时就医\n- 准备急救物品\n- 记住急救电话\n\n10. 长期照护\n10.1 照护计划\n- 评估需求\n- 制定方案\n- 定期评估\n- 及时调整\n\n10.2 照护资源\n- 家庭照护\n- 社区服务\n- 专业机构\n- 志愿者服务\n\n通过科学的健康管理，老年人可以更好地维护身体健康，提高生活质量。记住，预防胜于治疗，及早发现和干预健康问题，才能更好地享受晚年生活。',
          publishTime: '2024-03-30',
          isPaid: true,
          price: 15.9
        },
        1014: {
          id: 1014,
          title: '老年人健康指南：日常保健与疾病预防（下）',
          category: '老年人健康',
          content: '11. 重视口腔保健\n坚持饭后漱口、早晚刷牙，合理使用牙线或牙签；每隔半年进行1次口腔检查，及时修补龋齿孔洞；及时镶补缺失牙齿，尽早恢复咀嚼功能。\n\n12. 预防跌倒\n老年人90%以上的骨折由跌倒引起。平时应当保持适度运动，佩戴适当的眼镜以改善视力，避免单独外出和拥挤环境，室内规则摆放物品，增加照明，保持地面干燥及平整。\n\n13. 预防骨关节疾病和预防骨质疏松症\n注意膝关节保暖，避免过量体育锻炼，尽量少下楼梯，控制体重以减轻下肢关节压力。增加日晒时间。提倡富含钙、低盐和适量蛋白质的均衡饮食，通过步行或跑步等适度运动提高骨强度。\n\n14. 预防压力性尿失禁\n注意改变使腹压增高的行为方式和生活习惯，如长期站立、蹲位、负重、长期慢性咳嗽、便秘等。\n\n15. 保持良好心态，学会自我疏导\n一旦发觉老年人出现失眠、头痛、眼花、耳鸣等症状，并且心情压抑、郁闷、坐卧不安，提不起精神，为一点儿小事提心吊胆、紧张恐惧，对日常活动缺乏兴趣，常常自卑、自责、内疚，处处表现被动和过分依赖，感到生活没有意义等或心情烦躁、疲乏无力、胸闷、睡眠障碍、体重下降、头晕头痛等抑郁症早期症状，要及时就诊，请专科医生进行必要的心理辅导和药物治疗。\n\n16. 预防阿尔茨海默病的发生发展\n阿尔茨海默病多数起病于65岁以后，主要表现为持续进行性的记忆、语言、视空间障碍及人格改变等。老年人一旦出现记忆力明显下降、近事遗忘突出等早期症状，要及早就诊，预防或延缓阿尔茨海默病的发生发展。\n\n17. 合理用药\n用药需严格遵守医嘱，掌握适应证、禁忌证，避免重复用药、多重用药。不滥用抗生素、镇静睡眠药、麻醉药、消炎止痛药、抗心律失常药、强心药等。不轻易采用“秘方”、“偏方”、“验方”、“新药”、“洋药”等。用药期间出现不良反应可暂时停药，及时就诊。',
          publishTime: '2025-06-12',
          isPaid: true,
          price: 8.9
        },
        1015: {
          id: 1015,
          title: "职业病知识科普（上）",
          category: "职业病知识科普",
          content: "一、什么是职业病？\n职业病是指企业、事业单位和个体经济组织等用人单位的劳动者，在职业活动中，因接触粉尘、放射性物质和其他有毒、有害因素而引起的疾病。必须具备以下四个条件，缺一不可：（1）患者主体是企业、事业单位或个体经济组织等用人单位的劳动者；（2）必须是在从事职业活动的过程中产生的；（3）必须是因为接触粉尘、放射性物质和其他有毒、有害物质等职业病危害因素引起；（4）必须是国家公布的职业病分类和目录所列的疾病。\n\n二、我国法定职业病包括哪些？\n我国法定职业病包括10类132种：（1）职业性尘肺病及其他呼吸系统疾病；（2）职业性皮肤病；（3）职业性眼病；（4）职业性耳鼻喉口腔疾病；（5）职业性化学中毒；（6）物理因素所致职业病；（7）职业性放射性疾病；（8）职业性传染病；（9）职业性肿瘤；（10）其他职业病。\n\n三、职业病防治主体责任是谁？\n（1）劳动者依法享有职业卫生保护的权利，用人单位应当为劳动者创造符合国家职业卫生标准和卫生要求的工作环境和条件，并采取措施保障劳动者获得职业卫生保护。\n（2）用人单位应当建立、健全职业病防治责任制，加强对职业病防治的管理，提高职业病防治水平，对本单位生产的职业危害承担责任。用人单位的主要负责人对本单位的职业病防治工作全面负责。\n\n四、哪些行业和工种易患尘肺病？\n（1）矿山开采：各种金属矿山的开采，煤矿的掘进和采煤以及其它金属矿山的开采，是生产尘肺的主要作业环境，主要作业工种是凿岩、爆破、支柱、运输；（2）金属冶炼：含金属矿石的粉碎、筛分和运输；（3）机械制造业：铸造配砂、造型、铸件的清砂、喷砂以及电焊作业；（4）建材行业：如耐火材料、玻璃、水泥、石料生产中的开采、破碎、研磨、筛选、搅拌等；石棉的开采、运输和纺织；（5）公路、铁路、水利建设中的开凿隧道、爆破等。\n\n五、防尘防毒措施主要有哪些？\n防尘措施主要包括密闭设备、通风除尘、湿式作业、佩戴防尘口罩、加强宣传培训、定期进行工作场所粉尘浓度监测、做好上岗前和在岗期间的职业健康检查。\n防毒措施主要有：改革工艺、革新技术、通风排毒、杜绝跑冒滴漏，佩戴个体防毒防护用品、加强宣传培训、定期测定作业场所空气中毒物浓度，做好上岗前体检和在岗期间职业健康检查，并建立健康档案。",
          publishTime: "2025-06-12",
          isPaid: true,
          price: 8.96
        },
        1016: {
          id: 1016,
          title: "职业病知识科普（下）",
          category: "职业病知识科普",
          content: "六、如何预防铅中毒？\n铅及其无机化合物可通过呼吸道与胃肠道吸收。一般不经皮肤吸收。有机铅如醋酸铅可由少量经皮肤吸收；四乙基铅易经皮肤吸收。结束铅作业的工人应穿工作服，但不得穿工作服进食堂、宿舍和其他场所。饭前要用肥皂洗手，下班后淋浴更衣，不将工作服和家庭装放一起清洗。不在车间内吸烟进食。车间铅尘浓度高时，应戴防尘口罩。应定期做健康检查。\n\n七、为什么接触职业危害的劳动者要进行职业健康检查？职业健康检查包括哪几类？\n职业健康检查，是以预防为目的，针对劳动者所接触的职业病危害因素，通过选择特定的项目，进行定期或不定期的医学健康检查，及时将健康检查结果报告给用人单位和劳动者本人，以便及时采取干预措施，保护劳动者健康。\n职业健康检查包括上岗前、在岗期间、离岗时和离岗后医学随访以及应急健康检查。\n\n八、哪些人需要上岗前职业健康检查？\n下列人员应进行上岗前职业健康检查：\n（1）从事接触职业病危害因素作业的新录入人员，包括转岗到该种作业岗位的人员。\n（2）从事有特殊健康要求作业的人员，如高空作业、电工作业、职业机动车驾驶作业等。\n\n九、职业病病人都应该享有哪些待遇呢？\n第一，职业病病人依法享受国家规定的职业病待遇，用人单位应当按照国家有关规定，安排职业病病人进行治疗、康复和定期检查，对不适宜继续从事原工作的职业病病人，应当调离原岗位，并妥善安置。第二，职业病病人的诊疗、康复费用，伤残以及丧失劳动能力的职业病病人的社会保障，按照国家有关工伤保险的规定执行。用人单位没有参加工伤保险的，其医疗和生活保障由用人单位承担。第三，除依法享有工伤保险外，依照有关民事法律，有获得赔偿的权利的，有权向用人单位提出赔偿要求。\n\n十、职业病诊断需要哪些资料\n（1）劳动者职业史和职业病危害接触史(包括在岗时间、工种、岗位、接触的职业病危害因素名称等）；\n（2）劳动者职业健康检查结果；\n（3）工作场所职业病危害因素检测结果；\n（4）职业性放射性疾病诊断还需要个人剂量监测档案等资料；\n（5）与诊断有关的其他资料。",
          publishTime: "2025-06-12",
          isPaid: true,
          price: 8.9
        }
      };

      this.article = articles[articleId];
      if (!this.article) {
        this.$notification['error']({
          message: '错误',
          description: '文章不存在',
          duration: 2
        });
        this.$router.push('/infoListView');
        return;
      }

      this.$nextTick(() => {
        this.checkContentHeight();
      });
    },
    checkContentHeight() {
      const contentElement = this.$refs.contentBox;
      if (contentElement) {
        this.showReadMore = contentElement.scrollHeight > 300;
      }
    },
    handleReadMore() {
      if (this.article.isPaid) {
        this.showPaymentModal = true;
        return;
      }

      if (this.contentBoxStyle.maxHeight === '300px') {
        this.contentBoxStyle.maxHeight = 'none';
      } else {
        this.contentBoxStyle.maxHeight = '300px';
      }
    },
    closePaymentModal() {
      this.showPaymentModal = false;
    },
    handlePaymentConfirm() {
      this.showPaymentModal = false;
      this.contentBoxStyle.maxHeight = 'none';
    },
    getCategoryClass(category) {
      const classMap = {
        '就医相关': 'medical',
        '药品相关': 'medicine',
        '中医相关': 'tcm',
        '饮食相关': 'diet',
        '老年人健康': 'elderly',
        '职业病知识科普': 'Occupational'
      };
      return classMap[category] || '';
    },
    formatDate(dateStr) {
      return dateStr.replace(/-/g, '/');
    }
  }
}
</script>

<style scoped>
.article-details {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.article-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.article-header {
  margin-bottom: 30px;
}

.article-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 15px;
}

.category-tag {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
}

.category-tag.medical {
  background: #fef6e6;
  color: #d48806;
}

.category-tag.medicine {
  background: #e6fffb;
  color: #08979c;
}

.category-tag.tcm {
  background: #f0f5ff;
  color: #1d39c4;
}

.category-tag.diet {
  background: #f6ffed;
  color: #52c41a;
}

.category-tag.elderly {
  background: #fff3e6;
  color: #d48806;
}

.category-tag.Occupational {
  background: #fff7e6;
  color: #f4a708;
}

.publish-time {
  color: #999;
  font-size: 14px;
}

.price-tag {
  color: #f5222d;
  font-weight: bold;
  font-size: 16px;
}

.content-box {
  position: relative;
  overflow: hidden;
  transition: height 0.3s ease;
}

.article-content {
  line-height: 1.8;
  color: #333;
}

.article-content pre {
  white-space: pre-wrap;
  font-family: inherit;
  margin: 0;
}

.read-more {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  margin: 0;
  padding: 30px 0;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, transparent), color-stop(1, #FFFFFF));
  background-image: -moz-linear-gradient(top, transparent, #FFFFFF);
}

.readMoreButton {
  border-top: 1px solid #96d1f8;
  background: #65a9d7;
  background: -webkit-gradient(linear, left top, left bottom, from(#3e779d), to(#65a9d7));
  background: -moz-linear-gradient(top, #3e779d, #65a9d7);
  padding: 5px 10px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 1) 0 1px 0, rgba(0, 0, 0, 90) 0 0 10px, rgba(0, 0, 0, 90) 0 0 20px, rgba(0, 0, 0, 90) 0 0 30px;
  -webkit-box-shadow: rgba(0, 0, 0, 1) 0 1px 0;
  -moz-box-shadow: rgba(0, 0, 0, 1) 0 1px 0;
  text-shadow: rgba(0, 0, 0, .4) 0 1px 0;
  color: white;
  font-size: 14px;
  font-family: Georgia, serif;
  text-decoration: none;
  vertical-align: middle;
  display: inline-block;
}

.readMoreButton:hover {
  border-top-color: #28597a;
  background: #28597a;
  color: #ccc;
}

.readMoreButton:active {
  border-top-color: #1b435e;
  background: #1b435e;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #999;
}

/* Payment Modal Styles */
.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.payment-modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 360px;
  height: 576px;
  position: relative;
}

.payment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  h2{
    color: #0caf60 !important;
    font-weight: 500;
    margin-left: 48px;
  }
}

.payment-modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.payment-modal-body {
  text-align: center;
}

.payment-qr-code {
  width: 340px;
  height: 360px;
  margin-bottom: 15px;
}

.payment-amount {
  font-size: 16px;
  color: #f5222d;
  margin-bottom: 15px;
}

.payment-confirm-btn {
  background: #0caf60;
  color: white;
  border: none;
  padding: 8px 80px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.payment-confirm-btn:hover {
  background: #6bc49a;
}
</style>